import React, { createContext } from 'react';

export const SeeAnswersNotesContext = createContext({});

export const SeeAnswersNotesProvider = ({ children }) => {
  const [respostas, setRespostas] = React.useState([]);
  const [notasRespostas, setNotasRespostas] = React.useState({});
  const [interview, setInterview] = React.useState({});

  return (
    <SeeAnswersNotesContext.Provider
      value={{
        respostas,
        setRespostas,
        notasRespostas,
        setNotasRespostas,
        interview,
        setInterview,
      }}
    >
      {children}
    </SeeAnswersNotesContext.Provider>
  );
};
